import {
  Controller,
  UseControllerProps,
  useFormContext,
} from 'react-hook-form';

import CountryPicker, {
  CountryPickerProps,
} from 'components/@common/CountryPicker';
import OptionalLabel from 'components/@forms/OptionalLabel';

type Props = Pick<UseControllerProps, 'rules' | 'name'> &
  Omit<CountryPickerProps, 'onChange' | 'onBlur' | 'inputRef' | 'value'>;

const FormCountryPicker = ({ rules, name, label, ...rest }: Props) => {
  const { TextFieldProps, ...props } = rest;
  const { control } = useFormContext();

  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      render={({ field: { ref, name, ...field }, fieldState: { error } }) => {
        return (
          <CountryPicker
            inputRef={ref}
            label={<OptionalLabel label={label} required={rules?.required} />}
            TextFieldProps={{
              ...TextFieldProps,
              name,
              error: !!error,
              helperText: error?.message,
              autoComplete: 'country',
            }}
            {...field}
            {...props}
          />
        );
      }}
    />
  );
};

export default FormCountryPicker;
